import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import React from 'react'
import PropTypes from 'prop-types'
import { Game } from '../../../Core'

import * as actions from '../settings.actions'

import UIButton from '../../UI/UIButton'

/**
 *  Setting button on UI.
 */
const showSettingsMenu = ({ addPopup, showHelp }) => {
  addPopup('settings_menu')
  showHelp()
}
const HelpButton = ({ addPopup, showHelp }) => (
  <UIButton
    id="help"
    icon="icon-help"
    position="position--absolute right offset-top-1 z-index1"
    action={() => showSettingsMenu({ addPopup, showHelp })}
  />
)

const mapDispatchToProps = (dispatch) => ({
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  showHelp: bindActionCreators(actions.showHelp, dispatch),
})

HelpButton.propTypes = {
  addPopup: PropTypes.func,
  showHelp: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(HelpButton)
